import './utahpricecampus/style';
import FormStructure from './utahpricecampus/form_structure';

export default FormStructure;